export const API_URL = `https://forkify-api.herokuapp.com/api/v2/recipes/`;
export const TIMEOUT_SEC = 3;
export const RES_PER_PAGE = 10;
export const FIRST_PAGE = 1;
